import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteProps } from 'react-router';
import { EUserLevels, IUser } from '@relab/alstom-ptw-shared';

import { appState } from '../redux/selectors';
import { PrivateRoute } from './PrivateRoute';
import { RootState } from '../redux/types';

interface PProtectedRouteProps extends RouteProps {
  user?: IUser;
}

const PProtectedRoute = ({ component, user, ...rest }: PProtectedRouteProps) => {
  if (user) {
    if (user.userLevel === EUserLevels.Admin) {
      return <PrivateRoute component={component} {...rest} />;
    } else {
      return <Redirect to={{ pathname: '/' }} />;
    }
  } else {
    return <PrivateRoute component={component} {...rest} />;
  }
};

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
});

export const ProtectedRoute = connect(mapStateToProps)(PProtectedRoute);
